import { Link, useNavigate } from "react-router-dom";

function Home() {
  const navigate = useNavigate();

  const features = [
    ["🎥", "Lives immersifs", "Diffuse en direct et échange avec ta communauté.", "/lives-show"],
    ["⚡", "Vidéos courtes", "Publie du contenu rapide, moderne et viral.", "/video-shorts"],
    ["💎", "Coins & cadeaux", "Soutiens les créateurs avec des cadeaux virtuels.", "/coins-show"],
    ["🛡️", "Sécurité renforcée", "Une plateforme pensée pour protéger les utilisateurs.", "/security-show"],
  ];

  return (
    <>
      <style>
        {`
          @keyframes evoSpin {
            from { transform: rotateY(0deg); }
            to { transform: rotateY(360deg); }
          }

          @keyframes evoPulse {
            0%, 100% { box-shadow: 0 0 35px rgba(0,242,255,0.45); }
            50% { box-shadow: 0 0 70px rgba(0,242,255,0.95); }
          }

          @keyframes evoDot {
            0%, 100% { transform: scale(1); opacity: 1; }
            50% { transform: scale(1.4); opacity: 0.65; }
          }

          @keyframes featureCardIntro {
            0% { transform: rotateY(0deg); }
            20% { transform: rotateY(0deg); }
            40% { transform: rotateY(180deg); }
            70% { transform: rotateY(180deg); }
            90% { transform: rotateY(360deg); }
            100% { transform: rotateY(360deg); }
          }

          @keyframes cardGlowAfter {
            0%, 100% {
              box-shadow: 0 0 22px rgba(0,242,255,0.08);
              border-color: rgba(0,242,255,0.22);
            }
            50% {
              box-shadow: 0 0 32px rgba(0,242,255,0.35);
              border-color: rgba(0,242,255,0.55);
            }
          }
        `}
      </style>

      <div
        style={{
          position: "fixed",
          inset: 0,
          zIndex: 999999,
          overflowY: "auto",
          background:
            "radial-gradient(circle at top right, rgba(0,242,255,0.22), transparent 32%), radial-gradient(circle at bottom left, rgba(255,0,90,0.22), transparent 30%), #03070d",
          color: "#fff",
          fontFamily: "Arial, sans-serif",
        }}
      >
        <div
          style={{
            minHeight: "100vh",
            padding: "42px 18px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <div
            style={{
              width: 210,
              height: 210,
              borderRadius: "50%",
              border: "2px solid rgba(0,242,255,0.55)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: 24,
              position: "relative",
              animation: "evoPulse 2.4s ease-in-out infinite",
            }}
          >
            <span
              style={{
                position: "absolute",
                width: 12,
                height: 12,
                borderRadius: "50%",
                background: "#ff2a8a",
                top: 18,
                left: 54,
                boxShadow: "0 0 14px #ff2a8a",
                animation: "evoDot 1.8s ease-in-out infinite",
              }}
            />

            <img
              src="/evo.png"
              alt="EVO-LIVE"
              style={{
                width: 125,
                height: 125,
                borderRadius: "50%",
                objectFit: "cover",
                animation: "evoSpin 5s linear infinite",
              }}
            />
          </div>

          <h1 style={{ fontSize: 42, fontWeight: 900, letterSpacing: 2, margin: "0 0 10px" }}>
            EVO-LIVE
          </h1>

          <h2 style={{ fontSize: 18, fontWeight: 800, letterSpacing: 1, margin: "0 0 10px" }}>
            Streaming. Création. Liberté.
          </h2>

          <p style={{ color: "#9befff", fontSize: 14, marginBottom: 34, letterSpacing: 0.5 }}>
            Le live nouvelle génération
          </p>

          <div
            style={{
              maxWidth: 760,
              border: "1px solid rgba(0,242,255,0.35)",
              borderRadius: 26,
              padding: "28px 22px",
              background: "rgba(3, 10, 18, 0.78)",
              boxShadow: "0 0 35px rgba(0,242,255,0.16)",
            }}
          >
            <h3 style={{ color: "#00f2ff", fontSize: 28, marginTop: 0, marginBottom: 16 }}>
              L’application mobile arrive bientôt
            </h3>

            <p style={{ fontSize: 18, lineHeight: 1.65 }}>
              EVO-LIVE prépare une expérience sociale centrée sur les lives, les
              vidéos courtes, les créateurs et les interactions en temps réel.
            </p>

            <p style={{ color: "#d6faff", lineHeight: 1.6 }}>
              Une plateforme moderne, immersive et sécurisée, pensée pour Android
              et iOS.
            </p>
          </div>

          <div
            style={{
              marginTop: 28,
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(210px, 1fr))",
              gap: 14,
              width: "100%",
              maxWidth: 900,
              perspective: 1000,
            }}
          >
            {features.map(([icon, featureTitle, text, link], index) => (
              <div
                key={featureTitle}
                onClick={() => navigate(link)}
                style={{ height: 172, cursor: "pointer", perspective: 1000 }}
              >
                <div
                  style={{
                    position: "relative",
                    width: "100%",
                    height: "100%",
                    transformStyle: "preserve-3d",
                    animation: `featureCardIntro 7s ease-in-out ${index * 0.3}s 1 forwards, cardGlowAfter 3s ease-in-out ${7.2 + index * 0.3}s infinite`,
                    borderRadius: 22,
                    border: "1px solid rgba(0,242,255,0.22)",
                    boxShadow: "0 0 22px rgba(0,242,255,0.08)",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      inset: 0,
                      padding: 20,
                      borderRadius: 22,
                      background: "rgba(0, 12, 20, 0.82)",
                      border: "1px solid rgba(0,242,255,0.22)",
                      boxShadow: "0 0 22px rgba(0,242,255,0.08)",
                      backfaceVisibility: "hidden",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <div style={{ fontSize: 28, marginBottom: 10 }}>{icon}</div>
                    <div style={{ fontSize: 17, fontWeight: 900, color: "#fff" }}>
                      {featureTitle}
                    </div>
                    <p style={{ color: "#9befff", fontSize: 14, lineHeight: 1.45 }}>
                      {text}
                    </p>
                  </div>

                  <div
                    style={{
                      position: "absolute",
                      inset: 0,
                      padding: 20,
                      borderRadius: 22,
                      background:
                        "linear-gradient(145deg, rgba(0,242,255,0.18), rgba(0,12,20,0.92))",
                      border: "1px solid rgba(0,242,255,0.55)",
                      boxShadow: "0 0 32px rgba(0,242,255,0.35)",
                      backfaceVisibility: "hidden",
                      transform: "rotateY(180deg)",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <div style={{ fontSize: 30, marginBottom: 10 }}>🖐️</div>
                    <div
                      style={{
                        color: "#00f2ff",
                        fontSize: 18,
                        fontWeight: 900,
                        textShadow: "0 0 14px rgba(0,242,255,0.8)",
                      }}
                    >
                      Clique dessus
                    </div>
                    <p style={{ color: "#d6faff", fontSize: 13, lineHeight: 1.45, margin: "10px 0 0" }}>
                      Découvre la suite de cette fonctionnalité
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div
            style={{
              marginTop: 34,
              padding: "14px 24px",
              borderRadius: 18,
              background: "linear-gradient(135deg, #00f2ff, #00b7ff)",
              color: "#00121c",
              fontWeight: 900,
              boxShadow: "0 0 25px rgba(0,242,255,0.55)",
            }}
          >
            Bientôt disponible sur Android et iOS
          </div>
<p
  style={{
    marginTop: 34,
    fontSize: 13,
    color: "#6fd8e8",
  }}
>
  Contact professionnel
</p>

<a
  href="mailto:evo.contact@gmail.com"
  style={{
    display: "inline-block",
    marginTop: 6,
    color: "#00f2ff",
    fontSize: 15,
    fontWeight: 800,
    textDecoration: "none",
    padding: "6px 12px",
    borderRadius: 10,
    background: "rgba(0,242,255,0.08)",
    border: "1px solid rgba(0,242,255,0.25)",
    boxShadow: "0 0 12px rgba(0,242,255,0.2)",
  }}
>
  evo.contact@gmail.com
</a>

          <div
            style={{
              marginTop: 24,
              borderTop: "1px solid rgba(0,242,255,0.2)",
              paddingTop: 18,
              width: "100%",
              maxWidth: 650,
              display: "flex",
              justifyContent: "center",
              gap: 18,
              flexWrap: "wrap",
              fontSize: 14,
            }}
          >
            <Link to="/confidentialite" style={{ color: "#00f2ff", textDecoration: "none" }}>
              Confidentialité
            </Link>
            <Link to="/mentions-legales" style={{ color: "#00f2ff", textDecoration: "none" }}>
              Mentions légales
            </Link>
            <Link to="/contact" style={{ color: "#00f2ff", textDecoration: "none" }}>
              Contact
            </Link>
          </div>

          <p style={{ marginTop: 18, color: "#7ddff0", fontSize: 12 }}>
            EVO-LIVE SAS – Tous droits réservés
          </p>
        </div>
      </div>
    </>
  );
}

export default Home;